import { render, staticRenderFns } from "./EditTemplateDialog.vue?vue&type=template&id=8e635d5a&scoped=true&"
import script from "./EditTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EditTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplateDialog.vue?vue&type=style&index=0&id=8e635d5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e635d5a",
  null
  
)

export default component.exports